<template>
    <div class="individualCallsVue c-responsive-fixwidth">
        <div 
            ref="scrollContainer"
            class="o-ndividualArea c-common-space" 
            v-infinite-scroll="{ handler: handleScroll, distance: 10 }" 
            infinite-scroll-disabled="busy" 
            infinite-scroll-distance="10"
            style="min-height: 1px;"
        >
            <div v-for="(dateWiseCalls, key, index) in calls" 
                v-if="(key!='' && dateWiseCalls.length > 0)" 
                class="o-ndividualTable" :key="key"
            >
                <div class="c-common-space o-individual-calls">
                    <div class="custom-row o-no-padding">
                        <h5 :id="'element'+index"  class="h5"><i class="fa fa-calendar-o" aria-hidden="true"></i>{{getDate(key)}}</h5>
                        <a 
                            href="javascript: void(0)" 
                            v-if="jobAccessStatus!='View Access'" 
                            @click="openCloneModal(key)" 
                            class="c-common-btn c-common-btn--small"
                        >
                            <i class="fa fa-files-o" aria-hidden="true"></i> 
                            Clone
                        </a>
                        <a href="javascript: void(0)" 
                            v-if="jobAccessStatus!='View Access'" 
                            @click="openAdvanceClone(key)" 
                            class="c-common-btn c-common-btn--small"
                        >
                            <i class="fa fa-files-o" aria-hidden="true"></i> 
                            Advance Clone
                        </a>
                    

                        <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                            <label>Jump to day:</label>
                            <select @change="onSelectScrollTo($event)" v-model="selectedScrollDate" class="form-control">
                                <option 
                                    v-for="(call, key, index) in calls" :key="index" 
                                    v-if="call.length>0" 
                                    :value="'#element'+index"
                                >
                                    {{getDateScrollTO(key)}}
                                </option>
                            </select>
                            <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                        </div>
                        
                        <div class="o-customSelect o-custom-dropdown o-inline-block margin-left-md">
                            <label>Sort by:</label> 
                            <select v-model="selectedSortType" class="form-control" @change="changeSortType">
                                <option value="status">Unassigned</option>
                                <option value="start">Start time</option>
                                <option value="skill">Skill</option>
                            </select>
                            <span class="o-custom-drop-arrow"><i aria-hidden="true" class="fa fa-angle-down"></i></span>
                        </div>

                        <div class="custom-col text-right float-right">
                            <a  href="javascript: void(0)" v-if="(getPower('addCall') || addCallPower())" 
                                @click="addBulkCall(key)" 
                                class="c-solid-btn c-solid-btn--large c-solid-btn--green" 
                                :class="job && job.client && job.client.employer && 
                                job.client.employer[0].status && 
                                job.client.employer[0].status.name !='View Access' ? 
                                'c-solid-btn c-solid-btn--large c-solid-btn--green' :
                                'c-solid-btn c-solid-btn--large c-solid-btn--green disabled'"
                            >
                                <i class="fa fa-plus" aria-hidden="true"></i> 
                                Add Calls
                            </a>
                        </div>
                    </div>
                </div>
                
                <table class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                    <thead>
                        <tr>
                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Start time:</span></th>
                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">End time:</span></th>
                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Position</span></th>
                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right"><span class="o-no-margin-bottom">Employee</span></th>
                        
                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right text-center"><span class="o-no-margin-bottom">Rate/hr.</span></th>
                        <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10 table-td-border-right text-center"><span class="o-no-margin-bottom">Notes</span></th>
                        <th align="center" valign="top" class="o-accordion-subtext"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(call, id) in dateWiseCalls" :key="id"> 
                            <td :id="'backTo'+index+id" :ref="'backTo'+index+id" align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                <p>{{getTime(call.start)}}</p>
                            </td>
                            <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                <p>{{getTime(call.end)}}</p>
                            </td>
                            <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5">
                                <p>{{call.skill.name+'('+call.skill.priotiy+')'}}</p>
                            </td>
                            <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5 table-td-border-right">
                                <p v-if="(call.employee != null)" :class="{'text-danger':call.employee.deleted_at}">
                                    <span v-if="call.employee&&call.employee.employable">
                                        {{call.employee.employable.first_name+" "+call.employee.employable.last_name}}
                                        {{call.employee.seniority?"("+getRoundOffSkillSeniority(call.employee.seniority)+")":''}}
                                        <el-tooltip class="item" effect="dark" content="Confirmed" placement="top-end">
                                            <i 
                                                v-if="call.status.name=='Confirmed'" 
                                                aria-hidden="true" 
                                                class="fa fa-check confirm-check-icon-style el-tooltip item" 
                                                aria-describedby="el-tooltip-5474" 
                                                tabindex="0">
                                            </i>
                                        </el-tooltip>
                                    </span>
                                </p>
                            </td>                      
                            <td align="left" valign="top" class="o-rowtable-text-td table-td-border-top u-cmn-padding5  text-center table-td-border-right">
                                <p  v-if="call.rate"><label v-html="getCurrencyIcon()"></label>{{call.rate}}</p>
                                <p  v-else>- - -</p>
                            </td>
                            <td align="center" valign="top" class="o-rowtable-text-td table-td-border-top table-td-border-right u-cmn-padding10">
                                <div v-if="call.notes && call.notes.length>40" :class="{'o-green-icon o-tooltip-trigger':call.notes, 'notify-icon':true}">
                                    {{getNotes(call.notes)}}
                                    <i aria-hidden="true" class="fa fa-exclamation-circle"></i>
                                    <div class="tooltip c-common-box-shadow">
                                        {{call.notes && call.notes.length>0 ? call.notes:'- - -'}}
                                    </div>
                                </div>
                                <p v-else>{{call.notes && call.notes.length>0 ? call.notes:'- - -'}}</p>
                            </td> 
                            <td align="center" valign="top" class="o-table-block-btn o-rowtable-text-td table-td-border-top u-cmn-padding5 w-100">
                                <div class="fontsize-0">
                                
                                    <div class="o-table-block-btn">
                                        <a href="javascript: void(0)" 
                                            @click="editCalls(call)" 
                                            :class="(call.status.name!='Unassigned' || 
                                            jobAccessStatus == 'View Access') ?
                                            'disabled':''"
                                        >
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div class="o-table-block-btn">
                                        <a href="javascript: void(0)" 
                                            @click="deleteCall(call)" 
                                            :class="(call.status.name!='Unassigned' || 
                                            jobAccessStatus == 'View Access')?'disabled':''"
                                        >
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="calls.length == 0 && afterAPI == true" class="o-ndividualTable ">
            <div class="c-common-space o-individual-calls c-common-gradient c-common-box-shadow c-radius3">
                <div class="col-md-12 no-job-dispaly">
                    <i class="fa fa-frown-o" aria-hidden="true"></i>
                    <br />
                    No Data Stored
                </div>
            </div>
        </div>
        
        <modal name="edit-call"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button type="button" 
                                @click="closeEditCalls()" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" 
                                aria-label="Close">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Edit Call</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Start Time:</label>                                
                                        <date-picker name="start" v-validate="{required: true}" v-model="editCallData.start" :config="config"></date-picker>
                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>                                
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">End Time:</label>
                                        <div>
                                            <date-picker name="start" v-validate="{required: true}" v-model="editCallData.end" :config="config"></date-picker>
                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="status=='Unassigned'" class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text--fullwidth">Position:</label>
                                        <div class="o-cutsomSelect">
                                        <select class="form-control"  v-model="editCallData.skill_id">
                                            <option v-for="(position,positionIndex) in positions" :key="positionIndex" :value="position.id">{{position.name}}</option>
                                        </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Rate:</label>
                                        <div>
                                            <input v-model="editCallData.rate" type="text" class="form-control u-border-radius-0" placeholder="$ 100 USD">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Status:</label>
                                        <div>
                                            <input type="text" :value="status" class="form-control" placeholder="01:59 AM" disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="common-label-text common-label-text--fullwidth">Notes:</label>
                                        <div class="">
                                            <textarea v-model="editCallData.notes" class="form-control" rows="3" placeholder="Notes"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="closeEditCalls()" 
                                        data-dismiss="modal" 
                                        aria-label="Close" 
                                        class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue">
                                            <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="saveEditCall()" 
                                        class="c-solid-btn c-solid-btn--large c-solid-btn--green">
                                        <i class="fa fa-pencil" aria-hidden="true"></i> 
                                        Edit Call
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="call-clone"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button 
                                @click="closeCloneModal()" 
                                type="button" class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Basic Clone</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <h2 class="h2 text-center">{{selectedJobTitle}}</h2>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <hr class="o-modal-separetor" />
                                        </div>
                                    </div>
                                    <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                        <p class="ps2">This routine will duplicate all calls from the source date to another day within the same job. All calls already existing in that day will be deleted, so this tool should be used before adding additional calls that are not sourced from the original date.</p>
                                        <p class="ps2">To clone days to a date outside of the job's scope, it will be necessary to edit the job and extend the end date, otherwise the date will not appear in the dropdown box.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Clone
                                            <br />calls from:</label>
                                        <label class="common-label-input">
                                            {{getGlobalDate(cloneData.cloneFrom)}}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group ">
                                        <label class="common-label-text">Clone
                                            <br />calls to:</label>
                                        <label class="common-label-input">
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="cloneData.closeTo">
                                                    
                                                    <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.date">{{getGlobalDate(callDay.date)}}</option>
                                                </select>
                                            </div>
                                        </label>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a 
                                        href="javascript: void(0)" 
                                        @click="closeCloneModal()" 
                                        data-dismiss="modal" 
                                        aria-label="Close" 
                                        class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="cloneCall()" 
                                        class="c-solid-btn c-solid-btn--large c-solid-btn--green"
                                    >
                                        <i class="fa fa-plus" aria-hidden="true"></i> 
                                        Add Calls
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="advance-call-clone"  height="auto" :scrollable="true" class="modal-dialog modal-lg o-large-modal">
            <div id=""  tabindex="-1" role="dialog">
                <div   role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button 
                                @click="closeAdvanceClone()" 
                                type="button" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Advance Clone Call</h1>
                        </div>
                        <div class="c-common-box-shadow o-modal-body c-margin-bottom-10">
                            <div class="row">
                                <div class="col-sm-6">
                                        <div class="form-group o-no-margin">
                                            <label class="common-label-text">Clone From:</label>
                                            <label class="common-label-input">
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="advanceCloneData.callUnderSelectedDay">
                                                    <option v-for="(callDay, key) in callDaysForJob" :key="key" :value="callDay.calls" v-if="(callDay.calls.length>0)? true : false" v-bind:selected="key === 0">{{getGlobalDate(callDay.date)}}</option>
                                                </select>
                                            </div>
                                            </label>
                                        </div>
                                    <!-- <div class="form-group o-no-margin">
                                        <label class="common-label-text">Clone From:</label>
                                        <label class="common-label-input">
                                        <el-date-picker
                                            name="Start"
                                            class="custom_date"
                                            v-validate="{ required: true}"
                                            v-model="editCallData.start"
                                            type="date"
                                            format="yyyy/MM/dd"
                                            value-format="yyyy-MM-dd"
                                            placeholder="Pick a day">
                                        </el-date-picker>

                                        </label>
                                    </div> -->
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group o-no-margin">
                                            <label class="common-label-text">Insert Mode:</label>
                                            <label class="common-label-input">
                                            <div class="o-cutsomSelect">
                                                <select class="form-control" v-model="advanceCloneData.insertMode">
                                                    <option value="1">Merge calls into existing calls</option>
                                                    <option value="0">Replace all existing calls</option>

                                                </select>
                                            </div>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                        </div>

                        <div class="c-common-box-shadow c-bg-white c-margin-bottom-10">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="call-clone-table o-table-overflow">
                                        <div class="call-clone-table-head">
                                            <h4 class="ps1">Clone From</h4>
                                            <div class="o-floar-right">
                                                <h4 class="ps2 o-blue-medium-text">Select:</h4>
                                                <a href="javascript: void(0)" @click="selectAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'all')?'o-filter-active':''">All</a>
                                                <a href="javascript: void(0)" @click="selectNoneAllCall()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'none')?'o-filter-active':''">None</a>
                                            </div>

                                        </div>
                                        <div class="call-clone-table-body">
                                            <div class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    &nbsp;
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Start time
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    End time
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Skill
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Employee
                                                </div>
                                            </div>
                                            <div v-for="(call, callIndex) in advanceCloneData.callUnderSelectedDay" :key="callIndex" class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <input type="checkbox" name="o4" :value="call.id" v-model="advanceCloneData.selectedcallsToClone">
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{getTime(call.start)}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{getTime(call.end)}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{call.skill.name}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{(call.employee != null)?call.employee.employable.first_name + " " + call.employee.employable.last_name:"Not Assign"}}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="c-common-box-shadow c-bg-white c-margin-bottom-5">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="call-clone-table o-table-overflow-large">
                                        <div class="call-clone-table-head">
                                            <h4 class="ps1">Clone To</h4>
                                            <div class="o-floar-right">
                                                <h4 class="ps2 o-blue-medium-text">Select:</h4>
                                                <a href="javascript: void(0)" @click="selectAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'allDay')?'o-filter-active':''">All</a>
                                                <a href="javascript: void(0)" @click="selectNoneAllDay()" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilterDay == 'noneDay')?'o-filter-active':''">None</a>
                                            </div>

                                        </div>
                                        <div class="call-clone-table-body">
                                            <div class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    &nbsp;
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Date
                                                </div>
                                                <div class="call-clone-table-body-tr-td o-blue-regular-text">
                                                    Calls
                                                </div>

                                            </div>
                                            <div v-for="(dayCall,dayCallIndex) in callDaysForJob" :key="dayCallIndex" class="call-clone-table-body-tr">
                                                <div class="call-clone-table-body-tr-td">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <input type="checkbox" name="o4" :value="dayCall.date" v-model="advanceCloneData.selectedDaysToClone">
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{getGlobalDate(dayCall.date)}}
                                                </div>
                                                <div class="call-clone-table-body-tr-td">
                                                    {{dayCall.calls.length}} calls
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="closeAdvanceClone()" 
                                        data-dismiss="modal" aria-label="Close" 
                                        class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="saveAdvanceClone()" 
                                        class="c-solid-btn c-solid-btn--large c-solid-btn--green"
                                    >
                                        <i class="fa fa-plus" aria-hidden="true"></i> 
                                        Clone Calls
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>        
    </div>
</template>

<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    import { bus } from '../../../main';
    import service from '../../../services.js';
    import { scroller } from 'vue-scrollto/src/scrollTo';
    
    export default {
        data() {
            const dataProps = {
                selectedScrollDate: "",
                polling: null,
                userClientID:'',
                jobAccessStatus:'',
                unassignedStatusId:'0169fbd1-aec7-4f66-ad42-e318f453d104',
                callNotes:'',
                selectedFilter: 'none',
                selectedFilterDay: 'noneDay',
                jobStart: null,
                jobEnd: null,
                selectedSortType: '',
                calls: [],
                lastDate: '',
                storeMore: [],
                callDaysForJob: [],
                afterAPI: false,
                editCallData: {
                    start: '',
                    end: '',
                    notes: '',
                    rate: '',
                    skill_id: '',
                    date: ''
                },
                positions: {},
                status: '',
                callId: '',
                advanceCloneData: {
                    selectedDaysToClone: [],
                    selectedcallsToClone: [],
                    insertMode: 1,
                    assignments: 0,

                    callUnderSelectedDay: [],
                },
                cloneData: {
                    assignments: false,
                    cloneFrom: '',
                    closeTo: '',
                },
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        //vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDates().jobStart || time.getTime() > dataProps.getDates().jobEnd);
                    }
                },
                getDates: function() {
                    return {
                        jobStart: dataProps.jobStart,
                        jobEnd: dataProps.jobEnd
                    };
                }
            };
            return dataProps;
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                companyId: 'companyId',
                userID: 'userID',
                selectedJobTitle: 'selectedJobTitle',
                getLastPositionId: 'getLastPositionId'
            })
        },

        props: {
            sortType: {
                type: String,
                required: true
            },
            job:{
                type: Object,
                required: true  
            },
        },

        watch: {
            sortType: function(newData) {
                this.selectedSortType = newData;
                this.sortCalls();
                //console.log(newData);
            },
            job: function(newData){
                this.job=newData;
                // console.log(this.job);
                this.userClientID=newData.client_id;
                this.jobAccessStatus=newData.client.employer[0].status ? newData.client.employer[0].status.name:null;
            }
        },

        methods: {
            onSelectScrollTo(e) {
                //console.log(e.target.value);
                const firstScrollTo = scroller();
                firstScrollTo(e.target.value, 200, {
                    offset: -100
                });
            },
            addBulkCall(date='') {
                this.$router.push({
					path:'/addCall/'+ this.$route.params.jobId,
                    query: date!=''?{ date: date }: null
				});
            },

            getNotes(notes){
                return notes.slice(0,38)+'.. ';
            },

            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            changeSortType() {
                bus.$emit('sortTypeChanged', this.selectedSortType);
            },

            getCurrencyIcon(){
                let icon='';
                switch(this.getCurrency){
                    case 'usd':
                        icon = '$';
                        break;
                    case 'pound':
                        icon = '&#163;';
                        break;
                    default:
                        icon = '$';
                }
                return icon;
            },

            getDateScrollTO(str) {
                return moment(str, 'YYYY-MM-DD').format('DD MMM YYYY');
            },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            async sortCalls() {
                let self = this;
                switch (this.selectedSortType) {
                    case 'start':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                var dateA = moment(a.start);
                                var dateB = moment(b.start);
                                return dateA > dateB ? 1 : -1;
                                //return new Date(b.start) - new Date(a.start);
                            });
                        }
                        //console.log('Short By start time',this.calls);
                        break;
                    case 'status':
                        // console.log(this.calls);
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                if (a.status.name == "Unassigned") return -1;
                                if (a.status.name == 'Unconfirmed' || a.status.name == 'Confirmed' || b.status.name == 'Unconfirmed' || b.status.name == 'Confirmed') return 1;
                                return 0;
                            });
                        }
                        break;
                        //console.log('Short By status');
                    case 'skill':
                        for (let key in this.calls) {
                            this.calls[key].sort(function(a, b) {
                                //console.log("Skill..",a.skill.name);
                                if (a.skill.priotiy < b.skill.priotiy) return -1;
                                if (a.skill.priotiy > b.skill.priotiy) return 1;
                                return 0;
                            });
                        }
                        //console.log('Short By Skill');
                        break;
                    case 'seniority':
                        for (let key in this.callsBySorting) {
                            this.callsBySorting[key].sort(function(a, b) {
                                if (a.status.name == "Unassigned") return 1;
                                if (a.status.name == 'Unconfirmed' || a.status.name == 'Confirmed' || b.status.name == 'Unconfirmed' || b.status.name == 'Confirmed') return -1;
                                return 0;
                            });
                        }
                        let calls = this.callsBySorting;
                        for (let key in calls) {   
                            calls[key].forEach((item) => {
                                if((item.employee && !item.employee.seniority)||(item.employee && item.employee.seniority == '')) {
                                    item.employee.seniority = 0;
                                }else {
                                    if(item.employee){
                                        item.employee.seniority = parseFloat(item.employee.seniority);
                                    }
                                }                        
                            });
                        }

                        for (let key in calls) {
                            calls[key].sort((a, b) => {
                                if(a.status.name == 'Unassigned' || b.status.name == 'Unassigned') {
                                    return -1;
                                } else if(a.employee && b.employee) {
                                    if(a.employee && a.employee["seniority"]>=0 && b.employee && b.employee["seniority"]>=0) {
                                        if (parseFloat(a.employee.seniority) > parseFloat(b.employee.seniority)) return 1;
                                        if (parseFloat(a.employee.seniority) < parseFloat(b.employee.seniority)) return -1;
                                        if (a.employee.seniority == b.employee.seniority) {
                                            if(a.employee.employable && a.employee.employable.last_name && b.employee.employable && b.employee.employable.last_name) {
                                                var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                                if (nameA < nameB) {
                                                    return -1;
                                                }
                                                if (nameA > nameB) {
                                                    return 1;
                                                }
                                            }
                                        }
                                    } else {
                                        if(a.employee.employable && a.employee.employable.last_name && b.employee.employable && b.employee.employable.last_name) {
                                            var nameA = a.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                            var nameB = b.employee.employable.last_name.toUpperCase(); // ignore upper and lowercase
                                            if (nameA < nameB) {
                                                return -1;
                                            }
                                            if (nameA > nameB) {
                                                return 1;
                                            }
                                        }
                                    }
                                } else {
                                    return -1;
                                }
                                return 0;
                            });
                        }
                        this.calls = calls;
                        // console.log('Short By Skill', a.employee.seniority);
                        break;
                    default:
                        //console.log("default case..");
                }
            },

            editCalls(call) {
                this.$modal.show("edit-call");
                this.getPositions();
                this.editCallData.start = moment(call.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm A');//dateTimeConvert.extractTimeOnly(call.start);
                this.editCallData.end = moment(call.end, 'YYYY-MM-DD HH:mm:ss').format('HH:mm A'); //dateTimeConvert.extractTimeOnly(call.end);
                this.editCallData.notes = call.notes;
                this.editCallData.rate = call.rate;
                this.status = call.status.name;
                this.editCallData.skill_id = call.skill.id;
                var tempDate = call.called_at.split(" ");
                this.editCallData.date = tempDate[0];
                this.callId = call.id;
            },

            deleteCall(call) {
                this.$confirm('CALL will be removed from the records of CALL LIST. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('call/deleteCall', {
                            'call_id': call.id,
                            'user_id': this.userID,
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            this.$message({
                                type: 'success',
                                message: 'Delete completed'
                            });
                            this.getAllCalls();
                        }).catch((err) => {
                            console.log(err);
                        });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            saveEditCall() {
                /**
                    notes field missing in API
                    notes:this.editCallData.notes,
                **/
                let editCallFormData = {
                    start: this.editCallData.date + " " + moment(this.editCallData.start, 'HH:mm A').format('HH:mm:ss'),
                    end: this.editCallData.date + " " + moment(this.editCallData.end, 'HH:mm A').format('HH:mm:ss'),
                    rate: this.editCallData.rate,
                    call_id: this.callId,
                    notes: this.editCallData.notes,
                    skill_id: this.editCallData.skill_id,
                    user_id: this.userID
                };
                
                if (moment(this.editCallData.start, 'HH:mm A').format('HH:mm:ss')>=moment(this.editCallData.end, 'HH:mm A').format('HH:mm:ss')) {
                    editCallFormData.end=moment(editCallFormData.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                    //console.log("date Incrised",editCallFormData.end);
                }
                //console.log(editCallFormData);
                this.$Progress.start();
                service.post('call/updateAParticularCall', editCallFormData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.afterAPI = true;
                    this.$modal.hide("edit-call");
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call Updated Successfully.',
                        type: 'success'
                    });
                    this.getAllCalls();
                }).catch((err) => {
                    this.afterAPI = true;
                    console.log(err);
                    this.$Progress.finish();
                });
                //console.log(temp);
            },
            closeEditCalls() {
                this.$modal.hide("edit-call");
            },
            singleAssign(call, id) {
                this.$store.dispatch('setCall', call);
                this.$store.dispatch('setLastPositionId', id);
                // this.$router.push({
                //     path: '/singleAssign/' + this.$route.params.jobId
                // });
                //console.log(id);
                this.$router.push({
                    path: '/singleAssignCustom/' + this.$route.params.jobId
                });
            },
            cleaeAssign(call) {
                service.del('call/' + call.id + '/assign', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userId': this.userID,

                }).
                then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call cleared successfully.',
                        type: 'success'
                    });
                    this.getAllCalls();
                }).catch((err) => {
                    console.log(err);
                });
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    this.calls = Object.assign({}, this.calls, this.storeMore);

                    /*for(var dates in this.storeMore){
                        Vue.set(this.calls, dates, this.storeMore[dates]);
                    }*/

                    bus.$emit('onUpdateCallList', this.calls);
                    this.storeMore = [];
                    if (this.lastDate != '') {
                        await service.get('job/' + atob(this.$route.params.jobId) + '/call', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'nextDate': this.lastDate,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result;
                                if (this.storeMore.length != 0) {
                                    this.lastDate = Object.keys(this.storeMore)[Object.keys(this.storeMore).length - 1] + " " + Date().slice(16, 24);
                                    // console.log(Object.keys(this.lastDate));
                                } else {
                                    this.lastDate = '';
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    } else {
                        this.storeMore = [];
                    }
                    this.$nextTick(() => {
                        if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                            this.$refs.scrollContainer._checkScroll();
                        }
                    });
                }
            },
            async getAllCalls() {
                this.$Progress.start();
                let scrollPositionX = window.pageXOffset;
                let scrollPositionY = window.pageYOffset;
                await service.get('employerjob/' + atob(this.$route.params.jobId) + '/getJobCalls', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'employer-id': this.companyId,
                    })
                    .then(async(res) => {
                        //console.log("res.data.result", res.data.result);
                        this.calls = res.data.result;
                        bus.$emit('onUpdateCallList', this.calls);
                        this.$Progress.finish();
                        this.sortCalls();
                        this.afterAPI = true;
                        //console.log(res);
                        this.lastDate = Object.keys(this.calls)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                        await service.get('employerjob/' + atob(this.$route.params.jobId) + '/getJobCalls', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'nextDate': this.lastDate,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result;
                                //console.log(this.storeMore);
                                if (this.storeMore.length != 0) {
                                    this.lastDate = Object.keys(this.storeMore)[Object.keys(this.storeMore).length - 1] + " " + Date().slice(16, 24);
                                    // console.log(lastDate);
                                } else {
                                    this.lastDate = '';
                                }
                                if(this.getLastPositionId && this.getLastPositionId!=''){
                                    var positionID='#'+this.getLastPositionId;
                                    //console.log(positionID);
                                    const firstScrollTo = scroller();
                                    firstScrollTo(positionID, 200, {
                                        offset: -100
                                    });
                                    this.$store.dispatch('setLastPositionId', '');
                                }else {
                                    window.scrollTo(scrollPositionX, scrollPositionY);
                                    document.body.scrollPositionY;
                                }
                                    
                            }).catch((err) => {
                                console.log(err);
                            });
                    }).catch((err) => {
                        console.log(err);
                        this.afterAPI = true;
                        this.$Progress.finish();
                    });
            },

            async refreshCalls() {
                this.$Progress.start();
                let scrollPositionX = window.pageXOffset;
                let scrollPositionY = window.pageYOffset;
                await service.get('employerjob/' + atob(this.$route.params.jobId) + '/getJobCalls', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'employer-id': this.companyId,
                    })
                    .then(async(res) => {
                        this.calls = [];
                        //console.log("res.data.result", res.data.result);
                        this.calls = res.data.result;
                        bus.$emit('onUpdateCallList', this.calls);
                        this.$Progress.finish();
                        this.sortCalls();
                        this.afterAPI = true;
                        //console.log(res);
                        this.lastDate = Object.keys(this.calls)[Object.keys(this.calls).length - 1] + " " + Date().slice(16, 24);
                        await service.get('employerjob/' + atob(this.$route.params.jobId) + '/getJobCalls', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'nextDate': this.lastDate,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result;
                                //console.log(this.storeMore);
                                if (this.storeMore.length != 0) {
                                    this.lastDate = Object.keys(this.storeMore)[Object.keys(this.storeMore).length - 1] + " " + Date().slice(16, 24);
                                    // console.log(lastDate);
                                } else {
                                    this.lastDate = '';
                                }
                                if(this.getLastPositionId && this.getLastPositionId!=''){
                                    var positionID='#'+this.getLastPositionId;
                                    //console.log(positionID);
                                    const firstScrollTo = scroller();
                                    firstScrollTo(positionID, 200, {
                                        offset: -100
                                    });
                                    this.$store.dispatch('setLastPositionId', '');
                                }else {
                                    window.scrollTo(scrollPositionX, scrollPositionY);
                                    document.body.scrollPositionY;
                                }
                                    
                            }).catch((err) => {
                                console.log(err);
                            });
                    }).catch((err) => {
                        console.log(err);
                        this.afterAPI = true;
                        this.$Progress.finish();
                    });
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
                //return time;
            },
            getDate(dateTime) {
                return dateTimeConvert.localDateFull(dateTime);
            },
            getGlobalDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },
            getPositions() {
                this.$Progress.start();
                //console.log("getPositions called..");
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.positions = res.data.result;
                    //console.log(this.positions);
                    this.$Progress.finish();
                    this.afterAPI = true;
                }).catch((err) => {
                    this.afterAPI = true;
                    console.log(err);
                });
            },

            openCloneModal(cloneFrom) {
                this.$modal.show("call-clone");
                //this.cloneData.closeTo = this.job.start.split(" ")[0];
                this.cloneData.cloneFrom = cloneFrom.split(" ")[0];
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        //console.log(this.advanceCloneData.callUnderSelectedDay);
                        this.callDaysForJob = res.data.result;
                        this.cloneData.closeTo = this.callDaysForJob[0].date;
                        this.$Progress.finish();
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
            },
            cloneCall() {
                let fromData = {
                    from: this.cloneData.cloneFrom + " " + Date().slice(16, 24),
                    to: this.cloneData.closeTo, // + " " + Date().slice(16, 24),
                    job_id: this.job.id,
                    assign: (this.cloneData.assignments) ? 1 : 0,
                    user_id: this.userID
                };
                //console.log(fromData);
                service.post('call/clone', fromData, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.$modal.hide("call-clone");
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Call Clone Successfully.',
                            type: 'success'
                        });
                        this.getAllCalls();
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            closeCloneModal() {
                this.$modal.hide("call-clone");
            },
            openAdvanceClone(selectedCloneTo) {
                //console.log(selectedCloneTo);
                this.$Progress.start();
                service.get('call/callDaysForJob', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'job-id': atob(this.$route.params.jobId),
                    })
                    .then((res) => {
                        //console.log(this.advanceCloneData.callUnderSelectedDay);
                        this.callDaysForJob = res.data.result;
                        //console.log("Data", this.callDaysForJob);
                        for (let i = 0; i < this.callDaysForJob.length; i++) {
                            if (this.callDaysForJob[i].calls.length > 0) {
                                if (this.callDaysForJob[i].date.split(" ")[0] == selectedCloneTo) {
                                    this.advanceCloneData.callUnderSelectedDay = this.callDaysForJob[i].calls;
                                }
                                // this.advanceCloneData.callUnderSelectedDay = this.callDaysForJob[i].calls;
                                //return;
                            }
                        }
                        //callUnderSelectedDay
                        this.$Progress.finish();
                        //console.log(res);
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                this.$modal.show("advance-call-clone");
            },
            closeAdvanceClone() {
                this.$modal.hide("advance-call-clone");
            },

            selectAllDay() {
                this.selectedFilterDay = 'allDay';
                let self = this;
                this.callDaysForJob.forEach(function(call) {
                    self.advanceCloneData.selectedDaysToClone.push(call.date);
                    //console.log(emp.employable.id);
                });
            },
            selectNoneAllDay() {
                this.selectedFilterDay = 'noneDay';
                this.advanceCloneData.selectedDaysToClone = [];
            },
            selectAllCall() {
                this.selectedFilter = 'all';
                let self = this;
                this.advanceCloneData.callUnderSelectedDay.forEach(function(call) {
                    self.advanceCloneData.selectedcallsToClone.push(call.id);
                    //console.log(emp.employable.id);
                });
            },
            selectNoneAllCall() {
                this.selectedFilter = 'none';
                this.advanceCloneData.selectedcallsToClone = [];
            },
            saveAdvanceClone() {

                let fromData = {
                    call_ids: JSON.stringify(this.advanceCloneData.selectedcallsToClone),
                    clone_to_dates: JSON.stringify(this.advanceCloneData.selectedDaysToClone),
                    insert_mode: this.advanceCloneData.insertMode,
                    assign: this.advanceCloneData.assignments,
                    job_id: atob(this.$route.params.jobId),
                    user_id: this.userID
                };
                //console.log(fromData);
                //console.log(this.advanceCloneData);
                service.post('call/advanceCall', fromData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call Clone Successfully.',
                        type: 'success'
                    });
                    this.getAllCalls();
                    this.$modal.hide("advance-call-clone");
                }).catch((err) => {
                    console.log(err);
                });
            },

            pollData () {   
                this.polling = setInterval(() => {
                    // console.log("Visibulity: " + document.visibilityState);
                    // document.addEventListener('visibilitychange', () => {
                        if(document.visibilityState === 'visible'){
                            this.timerState = "Started"
                        }else {
                            this.timerState = "Paused"
                        }
                    // })                
                    if (this.timerState === "Started") {
                        // console.log("Call Api");
                        this.refreshCalls();
                    }
                }, 60000);
            }
        },

        mounted() {            
            $('.v--modal-overlay.scrollable').css('overflow-y','auto');
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },

        created() {
            this.jobAccessStatus= this.job.client.employer[0].status ? this.job.client.employer[0].status.name : null;
            this.userClientID=this.job.client_id;
            this.jobStart = new Date(this.job.start);
            this.jobStart.setDate(this.jobStart.getDate() - 1);
            this.jobEnd = new Date(this.job.end);
            this.selectedSortType = this.sortType;
            this.getAllCalls();
            bus.$on('onSaveNewCall', (data) => {
                this.getAllCalls();
            });
            this.pollData();
        },

        beforeDestroy () {
            clearInterval(this.polling)
        }
    }
</script>

<style scoped>

    .w-100 {
        width: 100px;
    }

    tbody, td {
        vertical-align: middle!important;
    }

    td a {
        margin: 2px!important;
    }
    .empty-list {
        height: 60px;
    }
    .o-custom-drop-time{
        padding-top: 19px; 
        padding-right: 15px;
    }
    .confirm-check-icon-style{
        background-color: green;
        border-radius: 100%;
        color: white;
        padding: 2px;
    }
</style>
